<h5 mat-dialog-title class="pb-0">{{data.title}}</h5>
<hr class="p-0 m-0">
<mat-dialog-content class="mat-typography p-0 ps-2">
    <div class="m-2 p-2">
        <div class="mb-1" *ngFor="let line of data.lines">
            <span>{{line}}</span>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="confirm()">Yes</button>
    <button mat-button (click)="cancel()">No</button>
</mat-dialog-actions>